import { MeshLambertMaterial } from 'three';
import loader from '../loader';
import Scene from '../Scene';
import eventHub from '@/scripts/eventHub';
import { isTouchDevice } from '@/scripts/utils';

export default class Model {
  constructor(id, opts) {
    this.config = {
      id,
      urlModel: `/models/${id}/model.obj`,
      textures: opts.textures,
      options: opts.configuration,
    };
    this.modelStructure = {};
    this.model = null;
    this.promises = [];

    Object.keys(this.config.textures).forEach((key) => {
      this.modelStructure[key] = { textures: {} };
    });
  }

  async load(callback) {
    await Promise.all([
      this.loadMesh(callback),
      ...this.loadTextures(callback),
    ]);

    this.createObject();
  }

  loadMesh(callback) {
    eventHub.$emit('addFileToQueue');

    return new Promise((resolve) => {
      loader.models.load(this.config.urlModel, (obj) => {
        this.model = obj;
        obj.children.forEach((child) => {
          this.modelStructure[child.name].mesh = child;
        });

        resolve();
      });
    }).then(callback);
  }

  loadTextures(callback) {
    const mobileSuffix = isTouchDevice() ? '__mobile' : '';
    Object.keys(this.modelStructure).forEach((childName) => {
      this.config.textures[childName].forEach((textureType) => {
        eventHub.$emit('addFileToQueue');

        const promise = new Promise((resolve) => {
          loader.textures.load(
            `/models/${this.config.id}/${childName}-${textureType}${mobileSuffix}.jpg`,
            (texture) => {
              this.modelStructure[childName].textures[textureType] = texture; // eslint-disable-line

              resolve();
            },
          );
        }).then(callback);

        this.promises.push(promise);
      });
    });

    if (this.promises.length === 0) this.promises.push(true);

    return this.promises;
  }

  createObject() {
    Object.keys(this.modelStructure).forEach((child) => {
      const indexChild = this.model.children.findIndex(meshChild => meshChild.name === child);
      const currentMesh = this.model.children[indexChild];

      currentMesh.material = new MeshLambertMaterial(this.config.options);

      Object.keys(this.modelStructure[child].textures).forEach((textureType) => {
        currentMesh.material[textureType] = this.modelStructure[child].textures[textureType];
      });
    });

    Scene.add(this.model);
  }
}
